<!--
 * Created by JackCui on 2021/12/2
 -->
<script>
  export default {
    name: 'summary-render',
    props: {
      node: Object
    },
    inject: ['formData'],
    methods: {
      slotsHandle (position) {
        const {slots} = this.node
        const slotsFn = slots?.[position]

        if (slotsFn) {
          return slotsFn(this.$createElement, { node: this.node, formData: this.formData }) || true
        }

        return null
      }
    },
    render (h) {
      const {
        viewContent = [],
        props,
        mainField = {},
        info: {hiddenStyle} = {}
      } = this.node
      const filterList = viewContent.filter(item => {
        return !item.mainField
      })
      return (
        <group 
          {...{
            props: {
              hideHeader: hiddenStyle,
              ...props,
              fold: false
            }
          }}
          scopedSlots={{
            header: this.slotsHandle('header'),
            afterTitle: this.slotsHandle('header_after'),
            headerOperate: this.slotsHandle('header_operate')
          }}
        >
          <template slot="header">
            <span>{mainField.name || ''}: {this.formData[mainField.apiName]}</span>
          </template>
          <sy-form size="small" class='form-summary' span={3}>
            {
              filterList.map(node => {
                const Component = node.viewComponentName
                node.props.isPureText = true
                if (Component === 'form-item-render') {
                  const {viewContent, props} = node
                  return (
                    <sy-form-item
                      {...{props}}
                      rules={null}
                      removeLabel={true}
                    >
                      <render viewContent={viewContent}/>
                    </sy-form-item>
                  )
                } else {
                  return <Component node={node}/>
                }
              })
            }
          </sy-form>

        </group>
      )
    }
  }
</script>
<style scoped lang="scss">
  .form-summary {
    overflow: hidden;

    ::v-deep .el-form-item__label {
      font-size: 14px !important;
      padding-right: 4px !important;
    }

    ::v-deep .el-form-item__content {
      color: #F70007;
    }
  }
</style>
